import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';

// Carga perezosa (Lazy Loading) de las páginas para Code Splitting y optimización de PageSpeed
const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const AddMember = lazy(() => import('./pages/AddMember'));
const WeeklyReport = lazy(() => import('./pages/WeeklyReport'));
const ReportHistory = lazy(() => import('./pages/ReportHistory'));
const LeadersCharts = lazy(() => import('./pages/LeaderCharts'));
const Influence = lazy(() => import('./pages/Influence'));
const EditMember = lazy(() => import('./pages/EditMember'));
const Reports = lazy(() => import('./pages/Reports'));
const AdminUsers = lazy(() => import('./pages/AdminUsers'));
const Organigrama = lazy(() => import('./pages/Organigrama'));
const AdminMiembros = lazy(() => import('./pages/AdminMiembros'));
const AdminCasas = lazy(() => import('./pages/AdminCasas'));
const AdminLideres = lazy(() => import('./pages/AdminLideres'));
const AdminConfig = lazy(() => import('./pages/AdminConfig'));
const Chat = lazy(() => import('./pages/Chat'));
const Discipleship = lazy(() => import('./pages/Discipleship'));
const AdminLogs = lazy(() => import('./pages/AdminLogs'));

// Componente Loading Spinner minimalista
const Loading = () => (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-slate-800"></div>
    </div>
);

function App() {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <div className="App">
                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path="/" element={<Login />} />

                        {/* Rutas protegidas con Layout (Navbar) */}
                        <Route element={<Layout />}>
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/nuevo-miembro" element={<AddMember />} />
                            <Route path="/editar-miembro/:id" element={<EditMember />} />
                            <Route path="/reporte-semanal" element={<WeeklyReport />} />
                            <Route path="/historial-reportes" element={<ReportHistory />} />
                            <Route path="/influencia" element={<Influence />} />
                            <Route path="/graficas" element={<LeadersCharts />} />
                            <Route path="/reportes" element={<Reports />} />
                            <Route path="/admin/usuarios" element={<AdminUsers />} />
                            <Route path="/admin/organigrama" element={<Organigrama />} />
                            <Route path="/admin/miembros" element={<AdminMiembros />} />
                            <Route path="/admin/lideres" element={<AdminLideres />} />
                            <Route path="/admin/casas" element={<AdminCasas />} />
                            <Route path="/admin/configuracion" element={<AdminConfig />} />
                            <Route path="/chat" element={<Chat />} />
                            <Route path="/discipulado" element={<Discipleship />} />
                            <Route path="/admin/logs" element={<AdminLogs />} />
                        </Route>

                        {/* Redirección por defecto */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Suspense>
            </div>
        </BrowserRouter>
    );
}

export default App;
